import { parse, stringify } from "qs"
import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import { routeTree } from "./routeTree.gen"

export function getRouter() {
  return createTanStackRouter({
    routeTree,
    // Explicit behavior overrides the document's `scroll-behavior: smooth`,
    // which breaks the router's scroll reset in Firefox.
    scrollRestorationBehavior: "instant",
    parseSearch: (search) =>
      parse(search, {
        ignoreQueryPrefix: true,
        decoder: (str, defaultDecoder, _charset, type) => {
          const decoded = defaultDecoder(str)

          if (type === "value" && /^-?\d+\.?\d*$/.test(decoded)) {
            const num = Number(decoded)

            return isNaN(num) ? decoded : num
          }

          return decoded
        },
      }),
    stringifySearch: (search) =>
      stringify(search, {
        addQueryPrefix: true,
      }),
  })
}
